import { useIsAuthenticated } from '@azure/msal-react'
import { useOutlookCalendars } from '../../../hooks/OutlookCalendar'
import { isMsalEnabled, signin, signout } from '../../../lib/msal/authConfig'
import { MenuItem } from '@szhsin/react-menu'
import { UnifiedAccountItem } from './UnifiedAccountItem'
import { useLocalStorage } from 'usehooks-ts'

export function OutlookCalendarSection() {
  const isAuthenticated = useIsAuthenticated()
  const { data: outlookCalendars = [] } = useOutlookCalendars()
  const [isExpanded, setIsExpanded] = useLocalStorage('outlookAccountExpanded', false)

  // If MSAL is disabled, show a message instead
  if (!isMsalEnabled) {
    return (
      <>
        <MenuItem disabled>Outlook</MenuItem>
        <MenuItem disabled>
          <i className='fa-solid fa-lock h-6 w-6 text-sm' aria-hidden='true' />
          Requires HTTPS or localhost
        </MenuItem>
      </>
    )
  }

  if (!isAuthenticated) {
    return (
      <MenuItem
        onClick={signin}
        className='group transition-colors duration-150'
      >
        <div className='flex items-center gap-2'>
          <div className='flex h-5 w-5 items-center justify-center rounded bg-blue-600 text-white transition-transform duration-150 group-hover:scale-110'>
            <i className='fab fa-microsoft text-xs' aria-hidden='true' />
          </div>
          <span className='text-sm'>Sign in with Outlook</span>
        </div>
      </MenuItem>
    )
  }

  return (
    <>
      <MenuItem disabled className='relative'>
        <span className='text-xs font-bold text-gray-400 dark:text-gray-400'>
          OUTLOOK
        </span>
      </MenuItem>
      <UnifiedAccountItem
        accountName='Outlook Calendar'
        accountEmail={undefined} // Could get from MSAL if needed
        calendars={outlookCalendars}
        onRemove={signout}
        provider='outlook'
        isExpanded={isExpanded}
        onToggleExpansion={() => setIsExpanded(!isExpanded)}
      />
    </>
  )
}
